import { Component, OnInit } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from "ngx-toastr";
import { UploadVM } from 'src/app/models/UploadVM';
import { CsvService } from 'src/app/core-services/csv.service';
import { Router } from '@angular/router';
import { UserRole } from 'src/app/Enum/Enum';
import { NgxSpinnerService } from "ngx-spinner";
import { timer } from 'rxjs';
import { switchMap, takeWhile, map, takeUntil } from 'rxjs/operators';
import { JobStatus } from './job-status-enum';
import { ResponseModel } from 'src/app/models/ResponseModel';


@Component({
  selector: 'app-upload-csv',
  templateUrl: './upload-csv.component.html',
  styleUrls: ['./upload-csv.component.scss']
})
export class UploadCsvComponent implements OnInit {
  public files: NgxFileDropEntry[] = [];


  filetype: any;
  formData: FormData;
  responseHolder: any;
  importedfilePath = "";
  isFileUpload = false;
  fileName: any;
  loggedInUserData: any;
  csvUploadStsatusResponse: ResponseModel;
  timerSubscription;
  isUploadCompleted = false;

  constructor(private http: HttpClient, private toastr: ToastrService, private csvService: CsvService, private router: Router, private spinner: NgxSpinnerService) {
    this.loggedInUserData = JSON.parse(localStorage.getItem('currentUser'));
    if (this.loggedInUserData != null && this.loggedInUserData.usersDetailsVM != null) {
      if (this.loggedInUserData.usersDetailsVM.userRole != UserRole.SuperAdmin) {
        this.router.navigate(['/']);
        this.toastr.error('You are not authorized', 'error');
      }
    }
    else {
      this.router.navigate(['/']);
      this.toastr.error('You are not authorized', 'error');

    }
  }

  ngOnInit() {
    this.checkImportStatus();
  }
  getUrl(url: string): string {
    return environment.apiUrl + url;
  }

  onFileDropped(files: NgxFileDropEntry[]) {
    this.fileName = '';
    this.formData = new FormData();
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

        // if ((fileEntry.name.split('.')[1] == 'xls') || (fileEntry.name.split('.')[1] == 'xlsx')
        //   || (fileEntry.name.split('.')[1] == 'csv')) {
        if (fileEntry.name.split('.')[1] == 'csv') {

          fileEntry.file((file: File) => {

            this.formData.append(fileEntry.name, file);
            this.spinner.show();
            this.http.post<any>(this.getUrl(`api/Upload/UploadExcelAndCSVTemplate`), this.formData, { responseType: 'json' })
              .pipe()
              .subscribe(
                (response: any) => {
                  if (response != null) {
                    if (response != null && response.isSuccess && response.content != null) {
                      this.toastr.success('File Upload Sucessfully', 'Success');
                      this.importedfilePath = response.content;
                      this.fileName = droppedFile.fileEntry.name;
                      this.isFileUpload = true;
                    }
                  }
                  this.spinner.hide();
                },
                (err: HttpErrorResponse) => {
                  this.spinner.hide();
                });
          });
        }
        else {
          this.toastr.error('Please Upload CSV file less than 5 Mb', 'error');
        }
      }
      else {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }


  public fileOver(event) {
    console.log(event);
  }

  public fileLeave(event) {
    console.log(event);
  }

  checkImportStatus() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timerSubscription = timer(0, 120000).pipe( // switch to timer that emits every 5 seconds
      switchMap((t) => {
        return this.csvService.getImportStatus();
      })
    ).subscribe((data: any) => {
      if (!data.isSuccess) {
        if (this.timerSubscription) {
          this.timerSubscription.unsubscribe();
        }
        this.csvUploadStsatusResponse = new ResponseModel();
        this.csvUploadStsatusResponse.message = JobStatus.Failed;
        this.csvUploadStsatusResponse.isSuccess = false;
        this.fileName = '';
        this.importedfilePath = '';
      } else {
        this.isUploadCompleted = false;
        this.csvUploadStsatusResponse = data;
        if (this.csvUploadStsatusResponse.message !== JobStatus.Running) {
          if (this.csvUploadStsatusResponse.message === JobStatus.Completed) {
            this.isUploadCompleted = true;
            setTimeout(() => {
              this.isUploadCompleted = false;
            }, 5000);
            this.processImportCsvResult(this.csvUploadStsatusResponse);
          }
          this.timerSubscription.unsubscribe();
        }
      }
    }, (err) => {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      this.csvUploadStsatusResponse = new ResponseModel();
      this.csvUploadStsatusResponse.message = JobStatus.Failed;
      this.csvUploadStsatusResponse.isSuccess = false;
      this.fileName = '';
      this.importedfilePath = '';
    });
  }

  retry() {
    this.csvUploadStsatusResponse = new ResponseModel();
    this.csvUploadStsatusResponse.message = JobStatus.NoJob;
    this.csvUploadStsatusResponse.isSuccess = true;
    this.fileName = '';
    this.importedfilePath = '';
  }

  importcsv() {
    if (this.importedfilePath != null && this.importedfilePath != "" && this.loggedInUserData != null && this.loggedInUserData.usersDetailsVM != null) {
      var filedata = new UploadVM();
      filedata.fileName = this.importedfilePath;
      filedata.userId = this.loggedInUserData.usersDetailsVM.userId;
      this.spinner.show();
      this.csvService.importcsv(filedata).subscribe((response: any) => {
        this.checkImportStatus();
        this.spinner.hide();
      });
    }
    else {
      this.toastr.error('Please select CSV file', 'error');
    }
  }

  cancelUpload() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.csvUploadStsatusResponse.message = JobStatus.NoJob;
    this.fileName = '';
    this.importedfilePath = '';
  }

  private processImportCsvResult(response: ResponseModel) {
    this.fileName = '';
    this.importedfilePath = '';
    if (response != null && response.content != null) {
      if (response.content.errorData != null && response.content.errorData.length > 0) {
        this.csvService.downloadCsvFile(response.content.errorData, 'NotSavedData');
      }
      if (response.content.successData != null && response.content.successData.length > 0) {
        this.csvService.downloadCsvFile(response.content.successData, 'SavedData');
      }
    }
  }
}
